<template>
  <div id="app">
    <!-- <header-bar /> -->
    <router-view />
    <!-- <foot-bar /> -->
    <el-backtop class="el-backtop">
      <div class="click-top">
        <el-icon style="vertical-align: middle;color: #006434;">
          <Top />
        </el-icon>
      </div>
    </el-backtop>
  </div>
</template>

<style lang="scss" scoped>
.click-top img {
  margin-top: 6px;
  width: 24px;
}

:deep(.el-backtop) {
  right: 150px !important;
  bottom: 150px !important;
}
</style>